import { createApp } from "vue";
import Proofreader from "~/components/StaticPages/Proofreader";

document.addEventListener("DOMContentLoaded", () => {
  const app = createApp({
    components: { Proofreader }
  });
  app.mount("#proofreader");
});
